import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-content-item-popover', {
    position: 'absolute',
    top: '76.8px',
    width: '300px',
    lineHeight: '16px',
    fontSize: '12px',
});

cssRule('.tb-content-item-popover.tb-workbook, .tb-content-item-popover.tb-view', {
    top: '57.6px',
});

cssRule('.tb-content-item-popover.tb-workbook.tb-popover-right, .tb-content-item-popover.tb-view.tb-popover-right', {
    left: '-2px',
});

cssRule('.tb-content-item-popover.tb-view.tb-popover-left', {
    left: '18px',
});

cssRule('.tb-content-item-popover.tb-workbook.tb-popover-left', {
    left: '15px',
});

cssRule('.tb-content-item-popover-title', {
    fontSize: '15px',
    fontWeight: 'bold',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    maxHeight: '7.5em',
    wordWrap: 'break-word',
    overflow: 'hidden',
    lineHeight: '1.5em',
});

cssRule('.tb-content-item-popover-sheets', {
    float: 'right',
    paddingLeft: '6px',
    paddingTop: '2px',
});

cssRule('.tb-content-item-popover-description', {
    maxHeight: '7.5em',
    wordWrap: 'break-word',
    overflow: 'hidden',
    marginTop: '12px',
    lineHeight: '1.5em',
});

cssRule('.tb-content-item-popover-details', {
    marginTop: '12px',
    whiteSpace: 'nowrap',
});

cssRule('.tb-content-item-popover-details-row', {
    paddingBottom: '7px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-content-item-popover-label', {
    float: 'left',
    paddingRight: '12px',
    whiteSpace: 'nowrap',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-content-item-popover-value', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-content-item-popover-value-multiline', {
    overflow: 'hidden',
    whiteSpace: 'normal',
    maxHeight: '4.5em',
    lineHeight: '1.5em',
});

cssRule('.tb-content-item-metadata', {
    marginTop: '12px',
});

